import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  vehicles: [],
  loading: true,
}

const vehiclesSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    getCarrierVehiclesRequest(state) {
      state.loading = true
    },
    getCarrierVehiclesReply(state, { payload }) {
      state.loading = false

      if (payload) {
        state.vehicles = payload.vehicles
      }
    },
  },
})

export const { getCarrierVehiclesRequest, getCarrierVehiclesReply } =
  vehiclesSlice.actions

export default vehiclesSlice.reducer
